// MerchantOrdersScreen/banners.jsx

import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import dayjs from "dayjs";
import { getMerchantBanners } from "../../api/axios/requests";
import RatingFeed from "./ratingFeed";
import "../../css/orders-insight.css";

// Зураггүй баннерын дэвсгэр өнгө — эрэмбээр нь ээлжилнэ
const TONES = ["primary", "success", "info", "warning"];

export default function MerchantBanners() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadBanners = async () => {
      try {
        const res = await getMerchantBanners();
        if (!cancelled && res?.success) {
          setBanners(Array.isArray(res.data) ? res.data : []);
        }
      } catch (error) {
        console.error("getMerchantBanners error:", error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadBanners();

    return () => {
      cancelled = true;
    };
  }, []);

  const isEmpty = !loading && banners.length === 0;

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h4 className="header-title mb-1">Мэдээ, мэдээлэл</h4>
            <p className="text-muted mb-0">
              E24-ээс ирсэн шинэ мэдээлэл, урамшуулал
            </p>
          </div>

          {banners.length > 0 && (
            <span className="badge bg-primary-subtle text-primary">
              {banners.length} мэдээлэл
            </span>
          )}
        </div>

        {loading ? (
          <div className="banner-slide placeholder-glow">
            <span className="placeholder w-100 h-100 d-block" />
          </div>
        ) : isEmpty ? (
          // Доор үнэлгээний жагсаалт байгаа тул хоосон төлөвийг товч мөрөөр.
          <p className="text-muted small mb-0">Одоогоор шинэ мэдээлэл алга.</p>
        ) : (
          <Carousel
            className="banner-slider"
            interval={6000}
            indicators={banners.length > 1}
            controls={banners.length > 1}
            touch
          >
            {banners.map((banner, i) => (
              <Carousel.Item key={banner.id}>
                <div className="banner-slide">
                  {banner.image ? (
                    <div
                      className="banner-slide__media"
                      style={{ backgroundImage: `url(${banner.image})` }}
                    />
                  ) : (
                    <div
                      className={`banner-slide__media banner-slide__media--${
                        TONES[i % TONES.length]
                      }`}
                    />
                  )}

                  <div className="banner-slide__overlay" />

                  <div className="banner-slide__body">
                    {banner.label && (
                      <span className="badge bg-light text-dark mb-2">
                        {banner.label}
                      </span>
                    )}

                    <h5 className="banner-slide__title">{banner.title}</h5>

                    {banner.description && (
                      <p className="banner-slide__desc">{banner.description}</p>
                    )}

                    {banner.startAt && (
                      <small className="banner-slide__date">
                        <i className="mdi mdi-calendar-blank-outline me-1" />
                        {dayjs(banner.startAt).format("MM/DD")}
                      </small>
                    )}
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        )}

        {/* Хэрэглэгчийн үнэлгээ — байнга, сүүлийнх нь эхэндээ (2026-09-18). */}
        <RatingFeed />
      </div>
    </div>
  );
}
